<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import CreateFeedbackModel from "./create-feedback";
import DeleteFeedbackModel from "./delete-feedback";
import EditFeedbackModel from "./edit-feedback";
import { getTestimonials } from "../../../../api/services/cms.service";

/**
 * Manage Extras Page
 */
export default {
  page: {
    title: "Manage Extras",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    "create-feedback-model": CreateFeedbackModel,
    "delete-feedback-model": DeleteFeedbackModel,
    "edit-feedback-model": EditFeedbackModel,
  },
  data() {
    return {
      title: "Feedback verwalten",
      items: [
        {
          text: this.$i18n.t("extras.header.item"),
          active: true,
        },
      ],
      feedbacks: null,
      feedbackToDelete: null,
      feedbacktoEdit: null,
      showCreateFeedbackModel: false,
      showDeleteFeedbackModel: false,
      showEditFeedbackModel: false,
    };
  },
  async mounted() {
    await this.getAllFeedbacks();
  },
  methods: {
    clickCreateNewFeedback() {
      this.showCreateFeedbackModel = true;
    },
    realodPage() {
      window.location.reload();
    },
    async getAllFeedbacks() {
      let getAllFeedbacksFromFunction = await getTestimonials();
      if (getAllFeedbacksFromFunction.length > 0) {
        this.feedbacks = getAllFeedbacksFromFunction;
      }
    },
    clickDeleteFeedback(feedbackId) {
      this.feedbackToDelete = feedbackId;
      this.showDeleteFeedbackModel = true;
    },
    clickEditFeedback(feedbackId) {
      this.feedbacktoEdit = feedbackId;
      this.showEditFeedbackModel = true;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-6 col-xl-6 mb-4">
        <div
          class="p-3 text-center"
          style="
            border-radius: 4px;
            border: 2px dashed #a5a5a5;
            color: #a5a5a5;
            background: #fff;
            cursor: pointer;
            height: 150px;
          "
          @click="clickCreateNewFeedback()"
        >
          <b-row>
            <b-col md="3">
              <b-img
                class="mb-3"
                alt=""
                :src="require('@/assets/images/Create Feedback.png')"
                style="height: 120px"
              ></b-img>
            </b-col>
            <b-col md="9">
              <h6 class="mt-5">
                <i class="bx bx-plus-medical bx-tada mr-2"></i>
                Neues Feedback erstellen
              </h6>
            </b-col>
          </b-row>
        </div>
      </div>
      <!-- Simple Extra Card -->
      <div
        class="col-md-12 col-lg-6 col-xl-6 mb-4"
        v-for="(feedback, feedbackIndex) in feedbacks"
        :key="feedbackIndex"
      >
        <b-card style="height: 150px" no-body class="overflow-hidden p-3">
          <b-row>
            <b-col md="3">
              <b-card-img
                v-if="feedback"
                v-bind:src="feedback.photo"
                alt="Image"
                class="rounded-0"
                style="height: 100px; width: 100px"
              ></b-card-img>
              <b-card-img
                v-else
                src="https://s3.eu-central-1.amazonaws.com/ms-sissi.uploads/cms/testimonial-default-img.png"
                alt="Image"
                class="rounded-0"
                style="height: 80px; width: 100px"
              ></b-card-img>
            </b-col>
            <b-col md="9">
              <b-card-title>
                <h5 class="card-title text-limted-one-lines">
                  {{ feedback.name }}
                </h5>
              </b-card-title>
              <b-card-text class="text-limted-two-lines">
                {{ feedback.description }}
              </b-card-text>
              <b-button
                class="ml-2"
                variant="warning"
                @click="clickEditFeedback(feedback.id)"
              >
                <i class="bx bxs-pencil mr-1"></i>
                {{ $t("general.buttons.edit") }}</b-button
              >
              <b-button
                class="ml-2"
                variant="danger"
                @click="clickDeleteFeedback(feedback.id)"
              >
                <i class="bx bx-trash-alt mr-1"></i>
                {{ $t("general.buttons.delete") }}</b-button
              >
            </b-col>
          </b-row>
        </b-card>
      </div>
    </div>
    <!-- end row -->

    <!-- Create Feedback Model -->
    <create-feedback-model
      v-if="showCreateFeedbackModel === true"
      :visible="showCreateFeedbackModel"
      @close="showCreateFeedbackModel = false"
      @reload="realodPage()"
    />

    <!-- Delete Feedback Model -->
    <delete-feedback-model
      v-if="showDeleteFeedbackModel === true"
      :visible="showDeleteFeedbackModel"
      @close="showDeleteFeedbackModel = false"
      @reload="realodPage()"
      :feedbackID="feedbackToDelete"
    />

    <!-- Edit Feedback Model -->
    <edit-feedback-model
      v-if="showEditFeedbackModel === true"
      :visible="showEditFeedbackModel"
      @close="showEditFeedbackModel = false"
      @reload="realodPage()"
      :feedbackID="feedbacktoEdit"
    />
  </Layout>
</template>

<style scoped>
.text-limted-one-lines {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  -webkit-box-orient: vertical;
}
.text-limted-two-lines {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
}
</style>
